<template>
  <div class="footer">
    <router-link :class="[index == 2 ? 'fix' : '', active == index ? 'bc' : '']" :to="item.to" v-for="(item, index) in nav" :key="index" @click="toggle(index)">
      <p class="flex-center">
        <img :src="active == index ? item.imgs : item.img" alt="">
      </p>
      <div>{{ item.name }}</div>
    </router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
      nav: [{
        img: require('../../public/img/index.png'),
        imgs: require('../../public/img/index-active.png'),
        name: '资产',
        to: '/'
      },{
        img: require('../../public/img/notice.png'),
        imgs: require('../../public/img/notice-active.png'),
        name: '资讯',
        to: '/notice'
      },{
        img: require('../../public/img/partner.png'),
        imgs: require('../../public/img/partner.png'),
        name: '合作伙伴',
        to: '/partner'
      },{
        img: require('../../public/img/store.png'),
        imgs: require('../../public/img/store-active.png'),
        name: '商城',
        to: '/store'
      },{
        img: require('../../public/img/profile.png'),
        imgs: require('../../public/img/profile-active.png'),
        name: '我的',
        to: '/profile'
      }]
    }
  },
  methods: {
    toggle(index) {
      this.active = index
    }
  },
  created() {
    this.nav.map((item, index) => {
      if(item.to == this.$route.path) {
        this.active = index
      }
    })
  }
}
</script>

<style scoped lang="scss">
  .footer {
    background-color: var(--cl);
    height: 3.0625rem;
    font-size: 0.625rem;
    display: flex;
    align-items: center;
    position: fixed;
    // max-width: 640px;
    width: 100%;
    bottom: 0;
    color: var(--c6);
    box-shadow: 0px -1px 6px 1px rgba(0,0,0,0.05);
    a {
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .flex-center {
        width: 1.375rem;
        height: 1.1875rem;
      }
      &.fix {
        position: relative;
        top: -.5rem;
        .flex-center {
          width: 3.125rem;
          height: 3.125rem;
          border: 0.4375rem solid var(--cl);
          border-radius: 50%;
        }
        div {
          position: relative;
          top: -.5rem;
        }
      }
      &.bc {
        color: var(--bc);
      }
    }
  }
</style>
